import React from "react";

/**
 * Page header matching the real AMC app look:
 * [big purple rounded icon] Title ................ [status badge]
 *                           subtitle
 */
export default function PageHeader({ icon: Icon, title, subtitle, status, right, variant = "primary" }) {
  const iconColors = {
    primary: "bg-[#7c3aed]/10 text-[#7c3aed]",
    building: "bg-[#1e3a8a]/10 text-[#1e3a8a]",
    green: "bg-emerald-100 text-emerald-600",
    red: "bg-red-100 text-red-600",
  };
  return (
    <div className="flex items-start gap-4">
      {Icon && (
        <div className={`w-14 h-14 rounded-2xl flex items-center justify-center shrink-0 ${iconColors[variant]}`}>
          <Icon className="w-6 h-6" strokeWidth={2.4} />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-3 flex-wrap">
          <h1 className="font-heading text-2xl md:text-3xl font-extrabold text-[#1e3a8a] leading-tight">
            {title}
          </h1>
          {status}
        </div>
        {subtitle && <p className="text-slate-500 text-sm mt-1">{subtitle}</p>}
      </div>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  );
}
